<template>
    <div class="CurriculumEvaluation">
        <!-- 移动端返回键 -->
        <div class="return">
            <p @click="toReturn"></p>
        </div>
        <!-- 返回 -->
        <div class="toReturn" @click="toReturn">
            <img src="../../assets/img/nav_return.svg" />
            <h4>返回</h4>
        </div>
        <h1>课程总体评价</h1>
        <p class="disc">本评价为匿名评价,可以提供宝贵的意见或建议</p>
        <ul class="EvaluationWrap">
            <li v-for="(item,index) in evaluateItemList" :key="index" :class="evaluateValue[index] != 0?'light':''">
                <p>{{item.Name}}</p>
                <el-rate
                    v-model="evaluateValue[index]"
                    :max=4
                    :texts="texts"
                    :disabled="isDisabled"
                    disabled-void-icon-class="el-icon-star-off"
                    show-text>
                </el-rate>
            </li>
        </ul>
        <el-input
            type="textarea"
            :rows="6"
            placeholder="请说出你的想法"
            v-model="textarea">
        </el-input>
        <p class="submitBtn" :class="isDisabled?'disabledBtn':'normalBtn'" @click="submit">提交</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            evaluateValue:[],  // 评分的值
            texts:['不太满意', '基本满意', '较满意', '非常满意'],  // 评价
            isDisabled:false,
            textarea:'',  // 想法
            courseId:undefined,  // 课程id
            evaluateItemList:[],  // 获取评价项
        }
    },
    mounted(){
        // 获取课程id
        this.courseId = this.$route.query.courseId;

        // 获取获取评价项
        this.getEvaluateItem();
        // 获取评价内容
        this.getEvaluateCont();
    },
    methods: {
        // 获取评价内容
        getEvaluateCont(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId
            }
            this.$axios.post(Const_Api_Root+'api/Course/CommentDetail',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    //如果其中一项评分0，代表本课程未评价过 否则渲染评分,并不可修改
                    if(res.data.Data.Grade1 == 0) return;

                    this.isDisabled = true;
                    let i = -1;
                    for(let k in res.data.Data){
                        if(k.indexOf('Grade') != -1 && res.data.Data[k] != 0){
                            i++;
                            this.evaluateValue[i] = res.data.Data[k];
                        }
                    }
                    this.textarea = res.data.Data.Memo;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取获取评价项
        getEvaluateItem(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp
            }
            this.$axios.post(Const_Api_Root+'api/Course/GetCommentItems',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.evaluateItemList = res.data.Data;
                }else if(res.data.Status == -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'warning',
                        duration: 3000
                    });
                }else if(res.data.Status == -8){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 提交
        submit(){
            // 提交过 则不可提交
            if(this.isDisabled) return;

            for(let i=0;i<this.evaluateValue.length;i++){
                if(this.evaluateValue[i] == 0){
                    this.$message({
                        message: '请先评分再提交！',
                        type: 'warning',
                        duration: 4000
                    });
                    return;
                }
            }
            
            this.submitData();
        },
        submitData(){
            //评分
            let grades = "";
            for(let i=0;i<this.evaluateValue.length;i++){
                grades = grades + this.evaluateValue[i];
            }

            if(this.textarea == ''){
                this.textarea = '无';
            }
            
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "Grades":grades,
                "Memo":this.textarea
            }
            this.$axios.post(Const_Api_Root+'api/Course/PutComment',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.$router.push('/submitSuccess');
                    this.isDisabled = true;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 移动端返回
        toReturn(){
            window.history.go(-1);
        }
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .CurriculumEvaluation{
        width: 100%;
        padding: 0 17px;
        box-sizing: border-box;
        h1{
            font-size: 20px;
            margin: 20px 0 10px;
        }
        .disc{
            font-size: 12px;
            margin-bottom: 20px;
        }
    }
    // 评价区域
    .EvaluationWrap{
        li{
            width: 100%;
            p{
                font-size: 12px;
				margin-left: 5px;
            }
        }
    }
    // 返回
    .return{
        height: 60px;
        display: flex;
        align-items: center;
        p{
            width: 30px;
            height: 30px;
            background: url('../../assets/img/nav_return.svg') no-repeat;
            background-size: 100% 100%;
        }
    }
    .toReturn{
        display: none;
    }
    .submitBtn{
        margin: 40px auto 20px;
    }
}
@media screen and (min-width: 1029px) {
    .CurriculumEvaluation{
        width: 800px;
        margin: 0 auto;
        .return{
            display: none;
        }
        h1{
            font-size: 30px;
            text-align: center;
            margin-top: 90px;
        }
        .disc{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            text-align: center;
            margin-top: 20px;
        }
    }
    .EvaluationWrap{
        li{
            width: 380px;
            p{
                font-size: 13px;
				margin-left: 10px;
            }
        }
    }
    .submitBtn{
        margin: 38px auto 384px;
    }
    .toReturn{
        width: 60px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        h4{
            font-size: 14px;
            font-weight: bold;
        }
        img{
            width: 30px;
            height: 30px;
        }
    }
}
// 公用
.CurriculumEvaluation{
    h1{
        text-align: center;
    }
    .disc{
        color: rgba(25,25,26,0.80);
        text-align: center;
    }
    .submitBtn{
        border-radius: 22px;
        font-size: 14px;
        color: #FFFFFF;
        width: 169px;
        line-height: 44px;
        text-align: center;
    }
    .normalBtn{
        cursor: pointer;
        background: #0061FE;
    }
    .disabledBtn{
        cursor: default;
        background: rgba(25,25,26,0.20);
    }
}
.EvaluationWrap{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 40px;
    li{
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid rgba(25,25,26,0.20);
        border-radius: 8px;
        height: 42px;
        color: rgba(25,25,26,0.20);

        position: relative;
        &:hover{
            border: 1px solid #0061FE;
            color: #19191a;
        }
        &:visited{
            border: 1px solid #19191A;
        }
    }
    .light{
        border: 1px solid #19191A;
        color: #19191a;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/class/CurriculumEvaluation.vue